import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../design-system';
import { TikTokIcon } from '../../../design-system/components/data-display/EmailProviderIcons';

interface TikTokVideoViewProps {
  url: string;
  title: string;
  description?: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 20px;
`;

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 360px;
  height: 100%;
  max-height: 100%;
  margin: 0 auto;
  
  /* Let the video scale to fit available height while maintaining aspect ratio */
  iframe {
    width: 100%;
    height: 100%;
    max-height: calc(100vh - 100px);
    object-fit: contain;
  }
`;

const VideoEmbed = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
  background: black;
`;

const ViewButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: white;
  background-color: #FE2C55;
  padding: 8px 14px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.15s ease;
  
  &:hover {
    background-color: #e0244a;
  }
`;

export const TikTokVideoView: React.FC<TikTokVideoViewProps> = ({ url, title, description }) => {
  // Extract video ID from URL
  const videoIdMatch = url.match(/\/video\/(\d+)/);
  const embedUrl = videoIdMatch ? `https://www.tiktok.com/embed/v2/${videoIdMatch[1]}` : null;
  
  if (!embedUrl) {
    return (
      <Container>
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <p style={{ color: colors.text.secondary }}>Unable to load TikTok video</p>
          <ViewButton href={url} target="_blank" rel="noopener noreferrer">
            <TikTokIcon size={16} />
            View on TikTok
          </ViewButton>
        </div>
      </Container>
    );
  }
  
  return (
    <Container>
      <VideoContainer>
        <VideoEmbed
          src={embedUrl}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </VideoContainer>
    </Container>
  );
};

